import {useLocation} from 'react-router-dom';
import React from 'react';
import {Exchange} from '../components/Exchange';
import {Notifications} from '../components/Notifications';
import {TransferFunds} from '../components/TransferFunds';
import {WithDraw} from '../components/WithDraw';
import {Footer} from './Footer';
import {Header} from './Header';
import {Sidebar} from './Sidebar';

export const MainLayout = ({children}) => {
  const location = useLocation();
  const path = location.pathname;

  const getBackgroundClass = (path) => {
    if (path === '/') {
      return 'gradient-bg';
    }

    return 'home-gradient-bg';
  };
  return (
    <div
      className=""
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div className={`desktop-border position-relative ${getBackgroundClass(path)}`}>
        <Header />
        <Sidebar />
        <Notifications />
        <TransferFunds />
        <WithDraw />
        <Exchange />
        <div className="page-content footer-clear">{children}</div>

        <Footer />
      </div>
    </div>
  );
};
